export const ADMIN = {
    platform : 'Administrador de plataforma',
}

export const EVALUATE_USER_ROLE = 'Usuario evaluado'
export const LEAD_ADMIN = 'Administrador Líder'
